module.exports = __webpack_public_path__ + "img/NotFound.d8facdee.svg";